<template>
  <div class="o-retain o-retain--wall">
    <ul
      class="o-layout u-margin-bottom-none"
      data-cy="unit-search-results-list"
    >
      <li
        v-for="(item, i) in items"
        :key="i"
        class="o-layout__cell u-margin-bottom"
      >
        <CardListing
          :item="item"
          :indexnr="i"
          v-if="item.entitytypeid === 1 && item.isExclusive != true"
          @gtmDataLayer="dataLayer"
          :listheader="listheader"
        />
        <ComplexListing
          :item="item"
          :indexnr="i"
          v-if="item.entitytypeid === 2"
          @gtmDataLayer="dataLayer"
          :listheader="listheader"
        />
        <ExclusiveListing
          :item="item"
          :indexnr="i"
          v-if="item.entitytypeid === 1 && item.isExclusive === true"
          @gtmDataLayer="dataLayer"
          :listheader="listheader"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import CardListing from '@/components/Listing/CardListing.vue'
import ComplexListing from '@/components/Listing/ComplexListing.vue'
import ExclusiveListing from '@/components/Listing/ExclusiveListing.vue'

export default {
  name: 'PropertyListing',
  components: {
    CardListing,
    ComplexListing,
    ExclusiveListing,
  },
  props: {
    items: null,
    listheader: String,
  },
  methods: {
    getStatusName: function (status) {
      const statusInt = parseInt(status, 10)

      switch (statusInt) {
        case 0:
          return 'onbekend'
        case 1:
          return 'nieuw'
        case 2:
          return 'verhuurd'
        case 3:
          return 'verhuurd onder voorbehoud'
        case 4:
          return 'gereserveerd'
        case 5:
          return 'nieuw'
        default:
          return null
      }
    },
    getObjectTypeDatalayerName(objectType) {
      if (!objectType) {
        return null
      }
      const objectTypeInt = parseInt(objectType, 10)
      switch (objectTypeInt) {
        case 1:
          return 'woning'
        case 2:
          return 'project'
        case 3:
          return 'hoog segment'
        case 'unit':
          return 'woning'
        default:
          return null
      }
    },
    dataLayer(unit) {
      // Set characteristics
      console.log('test', unit.item)

      let characteristics = []
      if (unit.item.onlyMiddleRent) characteristics.push('middenhuur')
      if (unit.item.ageFrom == '50') characteristics.push('50+')
      if (unit.item.ageFrom == '55') characteristics.push('55+')
      if (unit.item.ageFrom == '65') characteristics.push('65+')
      if (unit.item.suitedForHomeSharers) characteristics.push('woningdelen')
      if (unit.item.prioritizeKeyProfessions)
        characteristics.push('sleutelberoepen')
      console.log('characteristics', characteristics)
      characteristics.length > 0
        ? (characteristics = characteristics.join(','))
        : (characteristics = '')

      // First datalayer event
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'action',
        eventCategory: 'search',
        eventAction: 'search_click',
        eventLabel: unit.listingType,
      })

      // Additional e-commerce event
      window.dataLayer = window.dataLayer || []
      let projectName = unit.item.complex
      if (projectName === null) {
        projectName = unit.item.street
      }

      window.dataLayer.push({
        event: 'ecommerce',
        event_name: 'select_item',
        woning_id: unit.item.entityguid, // TODO: Check Null @complex
        woning_locatie: unit.item.location,
        woning_status: this.getStatusName(unit.item.status),
        woning_kenmerk: characteristics,
        project_id: unit.item.complexguid,
        project_name: projectName,
        ecommerce: {
          currency: 'EUR',
          items: [
            {
              item_id: unit.item.entityguid,
              item_name:
                unit.item.street +
                ' ' +
                unit.item.houseNumber +
                ' ' +
                unit.item.city,
              item_index: unit.indexnr + 1,
              item_category: unit.item.city,
              item_category2: unit.item.complexguid,
              item_category3: projectName,
              item_category4: this.getStatusName(unit.item.status),
              item_category5: unit.item.suitedForHomeSharers,
              item_list_name:
                this.listheader === 'LABEL MISSING'
                  ? 'Zoekresultaten'
                  : this.listheader,
              price: unit.item.price
                ? unit.item.price.replace(/[^0-9]/g, '')
                : unit.item.complexPriceMin.replace(/[^0-9]/g, ''),
              quantity: 1,
            },
          ],
        },
      })
    },
  },
}
</script>
